import { ReactNode } from 'react';
import { View } from 'react-native';

type Props = {
  grid: ReactNode;
  action: ReactNode;
};

const Word = ({ grid, action }: Props) => {
  return (
    <View className="flex-1 flex-row">
      <View className="flex-[2]">{grid}</View>
      <View className="flex-[1] flex mr-7">{action}</View>
    </View>
  );
};

const Sentence = ({ grid, action }: Props) => {
  return (
    <View className="flex-1 px-5">
      <View style={{ flex: 2 }}>{grid}</View>
      <View style={{ flex: 1 }}>{action}</View>
    </View>
  );
};

export default {
  Word,
  Sentence,
};
